import { render, staticRenderFns } from "./BusinessTarget.vue?vue&type=template&id=04ad43ca&scoped=true&"
import script from "./BusinessTarget.vue?vue&type=script&lang=js&"
export * from "./BusinessTarget.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTarget.vue?vue&type=style&index=0&id=04ad43ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ad43ca",
  null
  
)

export default component.exports